import DToolTipAdapterContainer from "./DToolTipAdapterContainer";
import type { DToolTipDataAdapterData } from "./types";

/**
 * UI Platform DToolTip Adapter for SiteCore source data
 * @param {Object} - dataset - Source Data
 * @returns React.ReactElement
 */
const DToolTipDataAdapter = ({ dataset }) => {
	//-- Grab the data island
	const data: DToolTipDataAdapterData = window[`ui_platform_dtooltip_${dataset.guid}`] || null;

	return (
		<DToolTipAdapterContainer
			align={data.align ?? "right"}
			label={data.label ?? "-"}
			size={data.size ?? "default"}
			content={data.content}
		/>
	);
};

export default DToolTipDataAdapter;
